import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAmbulance } from '@fortawesome/free-solid-svg-icons';
import { useHandleSetEmergency } from '../dispatchPlus/Dispatch/Jobs/Job/Emergency';

export const SetEmergency = ({
    job, day, onSuccess,
}) => {
    const handleClick = useHandleSetEmergency({
        job, day, onSuccess,
    });

    return (
        <Button
            color="link"
            className={`site-link text-center mt-1 mb-1 ${job.assignments[day].isEmergency ? 'text-success' : 'text-muted'}`}
            onClick={handleClick}
        >
            <FontAwesomeIcon
                icon={faAmbulance}
                className="mr-1"
            />

            Emergency
        </Button>
    );
};